import { useRef, useState } from 'react';

import { Mimes } from '/constants/file';
import { ProgressiveLoading } from '/common/withLoading';

import type { IPreviewComponentProps } from '../types';
import { useVisibility } from '../handlers/useVisibility';

import { ImageStyled, PreviewContainer } from './styles';

export function ImagePreview({
  url,
  Fallback,
  spinnersize = 20,
  loading: externalLoading,
  ...rest
}: IPreviewComponentProps) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const containerRef = useRef<HTMLDivElement | null>(null);
  const isVisible = useVisibility(containerRef);

  const handleLoad = () => setLoading(false);
  const handleError = () => {
    setLoading(false);
    setError(true);
  };
  const showLoading = externalLoading || loading;

  return (
    <PreviewContainer ref={containerRef}>
      {error ? (
        <Fallback fallbackTitle='Image is invalid' {...rest} />
      ) : (
        <ProgressiveLoading isLoading={showLoading} size={spinnersize as number}>
          {isVisible && (
            <ImageStyled src={url} onLoad={handleLoad} onError={handleError} $loading={loading} {...rest} />
          )}
        </ProgressiveLoading>
      )}
    </PreviewContainer>
  );
}

ImagePreview.mimes = Mimes.Image;
